import React, {Component} from 'react';
import { Button, Form, Grid } from 'semantic-ui-react'
import {client} from '../../Client';
import {Redirect} from 'react-router-dom';
import 'react-date-picker/index.css'
import {convertNullToEmptyString} from '../../Helpers'
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage'
import MovimentiListTypeButton from "./MovimentiListTypeButton";

class PreviewDocumentoForm extends Component {
    constructor(props) {
        super(props);
        let fields = props.item ? convertNullToEmptyString(props.item):null;
        this.state = {
            movimento: props.item,
            fileName: props.fileName,
            documento: null,
            fields: fields,
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            error: null,
        };
        this.onOkClick = this.onOkClick.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
        this.previewDocumento = this.previewDocumento.bind(this)
    }

    componentWillReceiveProps(nextProps){
        console.log("Filename CHANGED: ", nextProps.fileName);
        if (this.props.fileName !== nextProps.fileName)
        {
            this.setState({fileName: nextProps.fileName}, ()=>{
                this.previewDocumento();
            });
        }
    }
    componentDidMount(){
        this.previewDocumento();
    }

    previewDocumento(){
        let movimento = this.state.movimento ? this.state.movimento : null;
        let fileName = this.state.fileName ? this.state.fileName : null;

        console.log("mov,filename=", movimento, fileName);
        this.setState({_loading: true, documento: null});
        client.previewDocumentoInMovimento(movimento, fileName).then(
            (response) => {
                if (response.ok){
                    response.blob().then((blob) => {
                        this.setState({
                            _loading: false,
                            error: null,
                            documento: URL.createObjectURL(blob),
                            documentoTipo: blob.type
                        }, ()=>{});
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                        });
                    });
                }
            }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });

        });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.onOkClick(this.state.movimento);
    }

    onOkClick(movimento) {
        if (this.props.onOkClick)
        {
            this.props.onOkClick(movimento);
        }
    }

    isLoadingInProgress(){
        return this.state._loading || this.state.dropdownNotaLoading || this.dropdownCommesseLoading;
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess || this.state.cancelSuccess){
            return <Redirect to={ {
                pathname: '/app/movimenti',
                state: {
                    from: this.props.location,
                    item: this.state.movimentoSaved,
                },
            }}/>
        }

        let documento = (<div style={{width: "100%", height: "100%"}}></div> );
        if (this.state.documento){
            if (this.state.documentoTipo.includes('pdf')){
                documento = (
                    <embed style={{width: "100%", height: "100%"}} src={this.state.documento}>

                    </embed>);
            }
            else{
                documento = (
                    <div style={{width: "100%", height: "100%"}}>
                    <img style={{width: "100%"}} src={this.state.documento} alt="Preview immagine associata al movimento">

                    </img>
                    </div>);

            }
        }
        let buttons = null;
        if (this.props.showButtons){
            buttons = (<Grid.Row style={{height:'80px'}}>
                <Grid.Column textAlign="center">
                    <Button primary type='submit' ><i className="close icon"/>Chiudi</Button>
                </Grid.Column>
            </Grid.Row>);
        }

        return (
            <Form style={{height:'100%'}} onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>
                <Grid style={{height:'100%'}}>
                    <Grid.Row style={{height:'100%', overflow: "scroll"}}>
                        <Grid.Column textAlign="center">
                        {documento}
                        </Grid.Column>
                    </Grid.Row>
                    {buttons}
                </Grid>
            </Form>)


    }
}

PreviewDocumentoForm.PropTypes = {
    item: PropTypes.object, // Il movimento
    fileName: PropTypes.string, // Nome del file scelto
    showButtons: PropTypes.boolean,
    onOkClick: PropTypes.func.isRequired,
}

PreviewDocumentoForm.defaultProps = {
    showButtons: true
};
export default PreviewDocumentoForm;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/PreviewDocumentoForm.jsx
 **/